export var isValueSelected = function isValueSelected(value, newValue) {
  if (newValue === undefined || value === undefined) {
    return false;
  }

  return Array.isArray(newValue) ? newValue.indexOf(value) >= 0 : value === newValue;
};